import { ICategoryType } from '@introspection/index';
import { Form, FormGroup } from '@rxdi/forms';
import { Component, css, html, LitElement, property } from '@rxdi/lit-html';
import { InputStyle } from '@rxdi/ui-kit/styles/form/input';

/**
 * @customElement category-forms
 */
@Component({
  selector: 'category-forms',
  styles: [
    InputStyle,
    css`
      input {
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 0px;
      }
      .content {
        padding: 10px 30px 10px 30px;
        border-bottom: 1px solid #e5e5e5;
        overflow: auto;
        min-height: 100px;
        max-height: 385px;
      }
      .is-invalid {
        box-shadow: 0 0 1px 1px #c95454;
      }
    `,
  ],
  template(this: CategoryFormComponent) {
    return html`
      <form
        name="category-form"
        @submit=${async () => {
          const validity = await this.form.updateValueAndValidity();

          if (!validity?.length) {
            this.dispatchEvent(
              new CustomEvent<Pick<ICategoryType, 'id'>>('submitted', {
                detail: {
                  id: this.form.value.categoryId,
                },
              })
            );
          }
        }}
      >
        <div class="content">
          <p>Category</p>
          <select name="categoryId" class="rx-select" placeholder="Choose category" required>
            ${[
              ...this.categories.map((category) => ({
                selected: this.model?.id === category.id,
                name: category.name,
                id: category.id,
              })),
            ].map((option) =>
              option?.selected
                ? html`<option value=${option?.id} selected>${option?.name}</option>`
                : html`<option value=${option?.id}>${option?.name}</option>`
            )}
          </select>
        </div>
        <div style="padding: 20px;">
          <sl-button style="width:100%;" type="submit" variant="primary">Choose Category</sl-button>
        </div>
      </form>
    `;
  },
})
export class CategoryFormComponent extends LitElement {
  @property({ type: Object })
  model: ICategoryType;

  @property({ type: Array })
  categories: ICategoryType[];

  @Form({
    name: 'category-form',
    strategy: 'change',
    strict: true,
  })
  form = new FormGroup({
    categoryId: '',
  });

  OnUpdateFirst() {
    const model = this.model || {};
    Object.keys(model).map((key: never) => {
      if (this.form.get(key) && model[key]) {
        this.form.setValue(key, model[key]);
      }
    });
  }
}
